/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";
import _ from "lodash";
import ApiHome from "../../../../../core/api/api.home";

export function AsideMenuList({ layoutProps }) {
  const [menu, setMenu] = useState([]);
  const location = useLocation();
  const [father, setFather] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const response = await ApiHome.getMenu();
        if (response.succeeded == true) {
          findFather(response.data);
        }
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);

  useEffect(() => {
    findFather(menu);
  }, [location]);

  const findFather = (input) => {
    if (_.isEmpty(input))
      input = menu;
    const current = location.pathname.split(/[?#]/)[0];

    input.forEach(function (item) {
      if (!_.isEmpty(item) && !_.isEmpty(item.url) && current === item.url) {
        setFather(item.url);
        return;
      }
      if (!_.isEmpty(item.listChild) && item.listChild.length > 0) {
        item.listChild.forEach(function (subitem) {
          if (!_.isEmpty(subitem) && !_.isEmpty(subitem.url) && current === subitem.url) {
            setFather(item.url);
            return;
          }
        });
      }
    });
    setMenu(input);
  }

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return (checkIsActive(location, url) || url === father)
      ? ` ${!hasSubmenu ? "menu-item-active" : ""} menu-item-open `
      : "";
  };

  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`} >
        {(!_.isEmpty(menu) && menu?.map((item, Index) =>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(item.url, (!_.isEmpty(item?.listChild) && item?.listChild.length > 0 ? true : false))}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
            key={Index}
          >
            <NavLink className="menu-link menu-toggle" to={item.url}>
              <span className="menu-icon">
                <i className={item.icon} />
                {/* <HomeIcon /> */}
              </span>
              <span className="menu-text " >  {item.displayName} </span>
              {!_.isEmpty(item?.listChild) && item?.listChild.length > 0 ?
                <i className="menu-arrow" />
                : <></>
              }
            </NavLink>
            {!_.isEmpty(item?.listChild) && item?.listChild.length > 0 ?
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">

                  {/* submenu */}
                  {(!_.isEmpty(item?.listChild) && item.listChild?.map((subitem, subIndex) =>
                    !_.isEmpty(subitem) ?
                      <li
                        className={`menu-item menu-item-submenu ${getMenuItemActive(
                          subitem.url, false
                        )}`}
                        aria-haspopup="true"
                        data-menu-toggle="hover"
                        key={subIndex}
                      >
                        <NavLink className="menu-link menu-toggle" to={{ pathname: subitem.url }}>
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">{subitem.displayName}</span>
                        </NavLink>
                      </li>
                      : <></>
                  ))}
                </ul>
              </div>
              : <></>
            }
          </li>
        ))}

        {<li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          {/* <NavLink className="menu-link" to="/agentCommision">
            <span className="menu-text">گروه کمیسیون</span>
          </NavLink> */}
        </li>
        }
        {/* <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/management", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/management">
            <span className="menu-icon">
              <ManagementIcon />
            </span>
            <span className="menu-text">مدیریت</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/roles", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/roles">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مجوزها</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/users", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/users">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">کاربران ادمین</span>
                </NavLink>
              </li>
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/usersSite", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/usersSite">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">کاربران سایت</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/contact", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/contact">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">تماس با ما</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/smsInfo", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/smsInfo">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">ارسال پیامک</span>
                </NavLink>
              </li>

            </ul>
          </div>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/amusement", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/amusement">
            <span className="menu-icon">
              <AmusementIcon />
            </span>
            <span className="menu-text">تفریحات</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/amusementService", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/amusementService">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت سرویس</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/amusementGroups", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/amusementGroups">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت دسته ها</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/amusementSituation", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/amusementPlace">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت مکان ها</span>
                </NavLink>
              </li>
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/createOrEditServiceOption", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/amusementServiceOption">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت گزینه های رزرو</span>
                </NavLink>
              </li>
              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/discountCoupons", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/discountCoupons">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">کد تخفیف</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/order", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/order">
            <span className="menu-icon">
              <BookingIcon />
            </span>
            <span className="menu-text">سفارش ها</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/ordersList", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/ordersList">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت سفارش ها</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/basket", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/basket">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت سبد های خرید</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/userPayment", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/userPayment">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت پرداخت ها</span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/returnOrder", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/returnOrder">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">استرداد</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/payment", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/payment">
            <span className="menu-icon">
              <PaymentIcon />
            </span>
            <span className="menu-text">پرداخت ها</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/portals", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/portals">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت درگاه </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/wallet", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/wallet">
            <span className="menu-icon">
              <PaymentIcon />
            </span>
            <span className="menu-text">کیف پول</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/userWithdrawals", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/userWithdrawals">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">درخواست های برداشت  </span>
                </NavLink>
              </li>

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/userTransactions", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/userTransactions">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">تراکنش های کیف پول  </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/testimonials", true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/testimonials">
            <span className="menu-icon">
              <TestimonialIcon />
            </span>
            <span className="menu-text">نظرات</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/testimonials", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/testimonials">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">مدیریت نظرات </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>

        <li className={`menu-item menu-item-submenu ${getMenuItemActive(
          "/testimonials", true
        )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/testimonials">
            <span className="menu-icon">
              <TestimonialIcon />
            </span>
            <span className="menu-text">مدیریت محتوا</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">

              <li
                className={`menu-item menu-item-submenu ${getMenuItemActive(
                  "/AboutUs", true
                )}`}
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <NavLink className="menu-link menu-toggle" to="/AboutUs">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">ارتباط با ما</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li> */}

      </ul>
    </>
  );
}
